import {
    CONFIGURATION_UPDATE,
    STORE_RESET
} from '../../actions/action-types';
import appInitialState from '../../store/appInitialState';

const initialState = appInitialState.configuration;

/**
 * This is the application state's configuration slice reducer
 *
 * @param {Object} state 
 * @param {Object} action
 * 
 * @usages
 *  appStore.dispatch(updateConfiguration({
 *      roofArea: 776,
 *      roofInclination: 23
 *  }));
 */
function configurationReducer(state = initialState, action) {

    switch(true) {

        case (action.type === STORE_RESET):
            
            state = {
                ...state,
                ...initialState
            };
            break;

        case (action.type === CONFIGURATION_UPDATE):

            state = {
                ...state,
                ...action.payload
            };
            break;

        default:

    }

    return state;
};

export default configurationReducer;